<template>
  <div class="main">
    <!-- banner -->
    <div class="ban" style="background-image: url('/images/ba0c1eb35598ad0d34d9ae0c732651fa.jpg');"></div>
    <!-- banner-end -->
    <!-- 内容 -->
    <div class="wp">
      <div class="g-top">
        <div class="tab">
          <ul>
            <li v-for="item in classIfyList" :key="item.chipId" :class="{ on: activeTab === item.chipId }">
              <a href="#" @click.prevent="setActiveTab(item.chipId)">
                {{ item.chipNameCn }}
              </a>
            </li>
          </ul>
        </div>
        <div class="cur">
          当前位置：
          <a href="/">首页</a>&gt;
          <a href="/product-center">产品中心</a>
        </div>
      </div>
    </div>
    <div class="wp is-pc">
      <el-row :gutter="5" style="padding: 35px 0;">
        <el-col :span="5" >
          <el-menu  class="el-menu-vertical-demo" @select="handleSelect"
          :default-active="defaultActive"
            background-color="#F7F7F7" text-color="#343232" active-text-color="#007DC7" :unique-opened="true">
            <div v-for="item in leftClassIfyList" :key="item.chipId">
              <el-submenu v-if="item.children && item.children.length > 0" :index="item.chipId.toString()">
                <template slot="title">
                  <span>{{ item.chipNameCn }}</span>
                </template>
                <!-- 递归渲染子菜单 -->
                <div v-for="child in item.children" :key="child.chipId">
                  <el-submenu v-if="child.children && child.children.length > 0"
                    :index="child.chipId.toString()">
                    <template slot="title">
                      <span>{{ child.chipNameCn }}</span>
                    </template>
                    <el-menu-item v-for="subChild in child.children" :key="subChild.chipId"
                      :index="subChild.chipId.toString()">
                      {{ subChild.chipNameCn }}
                    </el-menu-item>
                  </el-submenu>
                  <el-menu-item v-else :index="child.chipId.toString()">
                    <span>{{ child.chipNameCn }}</span>
                  </el-menu-item>
                </div>
              </el-submenu>
              <el-menu-item v-else :index="item.chipId.toString()">
                <span>{{ item.chipNameCn }}</span>
              </el-menu-item>
            </div>
          </el-menu>
        </el-col>
        <el-col :span="19">
          <div v-show="isShowTable">
            <!-- 搜索栏 - 只在有isFilter为true的字段时显示 -->
            <div v-if="hasSearchField" class="search-container">
              <el-form :inline="true" class="search-form">
                <el-form-item v-for="field in searchFields" :key="field.chipId" :label="field.chipNameCn">
                  <el-input v-model="searchFilters[field.randomKey]" :placeholder="`请输入${field.chipNameCn}`" clearable
                    style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="filterTableData">搜索</el-button>
                  <el-button @click="resetFilters">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="htmlText" class="html-content-container">
              <div class="html-content-wrapper">
                <div v-html="htmlText.textContent" class="html-content"></div>
              </div>
            </div>
            <!-- 产品信息表格 -->
            <div class="product-table">
              <div class="table-header">
                <div v-for="(item, index) in dataByJson" :key="item.chipId" class="table-cell header-cell" >
                  {{ item.chipNameCn }}
                </div>
              </div>
              <div class="table-body">
                <div v-for="(item, index) in filteredInfoList" :key="item.chipId"
                  :class="{ 'table-row-even': index % 2 === 0, 'table-row-odd': index % 2 === 1 }" class="table-row">
                  <div v-for="(headerItem, indexx) in dataByJson" :key="headerItem.chipId" class="table-cell body-cell"
                    style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
                    <div>
                      <div  v-if="headerItem.randomKey == 'fileUrl' ">
                       
                        <img  @click="downloadFile(item.chipId)" v-if="item.fileUrl == 'true'" src="/images/product/pdf.svg" alt="下载" style="width: 20px; height: 20px; cursor: pointer;">
                        <span v-else style="font-size: 12px;color: #d3d3d3;">暂无手册</span>
                      </div>
                      <div v-else>{{ getNestedValue(item.chipDetail, headerItem.randomKey) || '-' }}</div>
                    </div>
                    <div @click="handleConsult(item)" v-if="indexx === 0"
                      style="cursor: pointer;background: #007DC7;padding: 2px 12px;border-radius: 4px;color: white;margin-top: 5px;">
                      咨询</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="!isShowTable">
            <div class="click-to-open" @click="downloadFile(selectInfo.chipId || '')" v-if="selectInfo.fileUrl == 'true'">点击打开产品规格书</div>
            <div class="chip-container">
              <div class="chip-name"> {{ selectInfo.chipDetail ? selectInfo.chipDetail[dataByJson[0].randomKey] : '-' }}
              </div>
              <div class="chip-description">
                <img src="/images/product/pdf.svg" alt="">
                <div v-for="item in dataByJson" :key="item.randomKey" v-if="item.chipNameCn != '附件'">{{ item.chipNameCn
                }} :
                  {{ selectInfo.chipDetail ? selectInfo.chipDetail[item.randomKey] : '-' }}
                </div>
              </div>
            </div>
            <div class="chip-submit">
              <div class="chip-submit-title">特殊需求请填写联系信息</div>
              <div class="chip-submit-tip">填写您的电话和电子邮件信息将有助于我们及时与您取得联系，并尽快解决您的问题</div>
              <div class="chip-submit-form">
                <el-form :model="applyInfo" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
                  <!-- <div style="display: flex;"> -->
                  <el-form-item label="联系人" prop="contacts">
                    <el-input v-model="applyInfo.contacts"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号" prop="phoneNumber">
                    <el-input v-model="applyInfo.phoneNumber"></el-input>
                  </el-form-item>
                  <el-form-item label="公司名称" prop="companyName">
                    <el-input v-model="applyInfo.companyName"></el-input>
                  </el-form-item>
                  <!-- </div> -->

                  <el-form-item label="需求" prop="demand">
                    <el-input type="textarea" v-model="applyInfo.demand" :rows="6"></el-input>
                  </el-form-item>



                  <el-form-item>
                    <el-button style="width: 400px;background: #007DC7;" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="wp is-mobile">
        
              <div class="mobile-menu" v-if="type === 'mobile' || type === ''">
                <div class="mobile-menu-item" @click="handleSelectByMobile(item)" v-for="(item, index) in menuListByMobile" :key="index">{{ item.chipNameCn }}</div>
              </div>
              <div class="product-table" v-if="type === 'mobile_show_table'">
              <div class="table-header" v-if="type === 'mobile_show_table'">
                <div v-for="item in dataByJson" :key="item.chipId" class="table-cell header-cell">
                  {{ item.chipNameCn }}
                </div>
              </div>
              <div class="table-body">
                <div v-for="(item, index) in filteredInfoList" :key="item.chipId"
                  :class="{ 'table-row-even': index % 2 === 0, 'table-row-odd': index % 2 === 1 }" class="table-row">
                  <div v-for="(headerItem, indexx) in dataByJson" :key="headerItem.chipId" class="table-cell body-cell"
                    style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
                    <div>
                      <div 
                        v-if="headerItem.randomKey == 'fileUrl'">
                        <img  v-if="item.fileUrl == 'true'" @click="downloadFile(item.chipId)" src="/images/product/pdf.svg" alt="下载" style="width: 20px; height: 20px; cursor: pointer;">
                         <span v-else style="font-size: 12px;color: #d3d3d3;">暂无手册</span>

                      </div>
                      <div v-else>{{ getNestedValue(item.chipDetail, headerItem.randomKey) || '-' }}</div>
                    </div>
                    <div @click="handleConsult(item);type = 'mobile_show_zixun'" v-if="indexx === 0"
                      style="cursor: pointer;background: #007DC7;padding: 2px 12px;border-radius: 4px;color: white;margin-top: 5px;">
                      咨询</div>
                  </div>
                </div>
              </div>
            </div>
            
             <div v-show="type === 'mobile_show_zixun'">
            <div class="click-to-open" @click="downloadFile(selectInfo.chipId || '')" v-if="selectInfo.fileUrl == 'true'">点击打开产品规格书</div>
            <div class="chip-container">
              <div class="chip-name"> {{ selectInfo.chipDetail ? selectInfo.chipDetail[dataByJson[0].randomKey] : '-' }}
              </div>
              <div class="chip-description">
                <!-- <img src="/images/product/pdf.svg" alt=""> -->
                <div v-for="item in dataByJson" :key="item.randomKey" v-if="item.chipNameCn != '附件'">{{ item.chipNameCn
                }} :
                  {{ selectInfo.chipDetail ? selectInfo.chipDetail[item.randomKey] : '-' }}
                </div>
              </div>
            </div>
            <div class="chip-submit">
              <div class="chip-submit-title">特殊需求请填写联系信息</div>
              <div class="chip-submit-tip">填写您的电话和电子邮件信息将有助于我们及时与您取得联系，并尽快解决您的问题</div>
              <div class="chip-submit-form">
                <el-form :model="applyInfo" :rules="rules" ref="ruleForm" label-position="left" label-width="80px" class="demo-ruleForm">
                  <!-- <div style="display: flex;"> -->
                  <el-form-item label="联系人" prop="contacts">
                    <el-input v-model="applyInfo.contacts"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号" prop="phoneNumber">
                    <el-input v-model="applyInfo.phoneNumber"></el-input>
                  </el-form-item>
                  <el-form-item label="公司名称" prop="companyName">
                    <el-input v-model="applyInfo.companyName"></el-input>
                  </el-form-item>
                  <!-- </div> -->

                  <el-form-item label="需求" prop="demand">
                    <el-input type="textarea" v-model="applyInfo.demand" :rows="6"></el-input>
                  </el-form-item>



                  <el-form-item>
                    <el-button style="width: 100%;background: #007DC7;" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
    </div>
  </div>
</template>

<script>
import RequestUtil from '../utils/request';

export default {
  name: 'ProductCenter',
  data() {
    return {
      defaultActive: '',
      type: '',
      menuListByMobile: [],
      isShowTable: true,
      classIfyList: [],
      activeTab: 308, // 默认显示波导器件
      currentPage: 1,
      leftClassIfyList: [],
      originalClassIfyList: [],
      dataByJson: [],
      infoList: [],
      htmlText: '',
      hasSearchField: false,
      searchFields: [],
      searchFilters: {},
      filteredInfoList: [],
      selectInfo: {},
      applyInfo: {},
      rules: {
        contacts: [
          { required: true, message: '请填写联系人', trigger: 'blur' },
          { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' }
        ],
        phoneNumber: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请填写公司名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        demand: [
          { required: true, message: '请填写需求', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSelectByMobile(item) {
      let isTable = item.isTable
      if (isTable == "1") {
        // this.$message.warning('功能开发中');
        
                this.$router.push({
      path: '/product-center',
      query: {timestamp: Date.now(), type: 'mobile_show_table', parentId: item.chipId }  // 添加时间戳参数以触发刷新
    })
      } else {
        // this.getMenuListByMobile(item.chipId)
           this.$router.push({
      path: '/product-center',
      query: {timestamp: Date.now(), type: 'mobile', parentId: item.chipId }  // 添加时间戳参数以触发刷新
    })
      }
     
    },
     submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = this.applyInfo
            data.goodName = this.selectInfo.chipDetail ? this.selectInfo.chipDetail[this.dataByJson[0].randomKey] : '-'
            RequestUtil.post('/wx/sample/addSampleInfo', data).then(res => {
           
              this.$message.success('提交成功！');
              this.$refs['ruleForm'].resetFields();
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    handleConsult(item) {
      this.isShowTable = false;

      this.selectInfo = item;
    },



    handleSelect(index) {
   
      this.isShowTable = true;
      let id = undefined
  
      if(typeof index === 'string') {
        id = index.split('-').pop()
      }else{
    
        id = index
      }
      // let id = index.split('-').pop()
      RequestUtil.get(`/wx/product/classIfy`, { "parentId": id }).then(res => {
        res.push(
          {
            randomKey: 'fileUrl',
            chipNameCn: "附件"
          }
        )

        // 检查是否有isFilter为true的字段，如果有则添加搜索框
        this.hasSearchField = res.some(field => field.isFilter === true);
        this.searchFields = res.filter(field => field.isFilter === true);

        this.dataByJson = res
        // console.log(this.dataByJson, "头部")
      })
      RequestUtil.get(`/wx/product/eleChipInfoByWebId`, { "parentId": id }).then(res => {
        res.data.forEach(item => {
          item.chipDetail = JSON.parse(item.chipDetail)
          item.chipDetail.fileUrl = item.fileUrl
        })
        this.infoList = res.data
        this.filteredInfoList = [...res.data] // 初始化过滤列表
        // console.log(this.infoList, "数据")
      })
      try {
        this.htmlText = this.originalClassIfyList.find(item => {
          return item.chipId === Number(id);
        });
      } catch (error) {
        console.log(error);
      }
    },
    getMenuListByMobile(parentId) {
      if (!parentId){
        parentId = "0";
      };
      RequestUtil.get(`/wx/product/classIfy`, { "parentId": parentId }).then(res => {
        this.menuListByMobile = res;
        this.$forceUpdate();
      })
    },
    getAllClassIft() {
      RequestUtil.get('/wx/product/classIfyByTree').then(res => {
        this.classIfyList = this.handleTree(res.data, "chipId", "parentId");
        this.originalClassIfyList = res.data;
        this.classIfyList = this.classIfyList.sort((a, b) => a.orderNum - b.orderNum);
        const selected = this.classIfyList.filter(item => item.chipId === this.activeTab)[0];
        // this.handleSelect('309-310-311');
        if (selected && selected.children) {
          this.leftClassIfyList = selected.children;
        } else {
          this.leftClassIfyList = [];
        }
  
      })
    },

    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      };

      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];

      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }

      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }

      for (let t of tree) {
        this.adaptToChildrenList(t, childrenListMap, config);
      }
      return tree;
    },

    adaptToChildrenList(o, childrenListMap, config) {
      if (childrenListMap[o[config.id]] !== null) {
        o[config.childrenList] = childrenListMap[o[config.id]];
      }
      if (o[config.childrenList]) {
        for (let c of o[config.childrenList]) {
          this.adaptToChildrenList(c, childrenListMap, config);
        }
      }
    },

    setActiveTab(tabId) {
      this.activeTab = parseInt(tabId);
      const selected = this.classIfyList.filter(item => item.chipId === tabId)[0];
      if (selected && selected.children) {
        this.leftClassIfyList = selected.children;
      } else {
        this.leftClassIfyList = [];
      }
      console.log(this.leftClassIfyList);
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    downloadFile(chipId) {

      const route = this.$router.resolve({
  path: '/pdf-show',
  query: { chipId: chipId ,type: "product"}
});
window.open(route.href, '_blank');
    },

    filterTableData() {
      // 根据搜索条件过滤数据 - table值包含运算符时解析比较
      this.filteredInfoList = this.infoList.filter(item => {
        return this.searchFields.every(field => {
          const searchTerm = this.searchFilters[field.randomKey];
          if (!searchTerm) return true; // 如果没有搜索词，返回true（不过滤）

          const fieldValue = this.getNestedValue(item.chipDetail, field.randomKey);
          if (fieldValue === null || fieldValue === undefined || fieldValue === '-') return false;
          
          return this.compareWithOperator(fieldValue.toString().trim(), searchTerm.trim());
        });
      });
    },

    // 解析table中的运算符并与搜索值比较
    compareWithOperator(tableValue, searchValue) {
      // 先尝试模糊匹配
      if (tableValue.toLowerCase().includes(searchValue.toLowerCase())) {
        return true;
      }

      // 解析table值中的运算符
      const parsed = this.parseOperatorValue(tableValue);
      const searchNum = parseFloat(searchValue);
      
      if (isNaN(searchNum) || parsed === null) {
        return false;
      }

      // 根据解析的运算符进行比较
      switch (parsed.operator) {
        case '>=':
        case '≥':
          return searchNum >= parsed.value;
        case '<=':
        case '≤':
          return searchNum <= parsed.value;
        case '>':
          return searchNum > parsed.value;
        case '<':
          return searchNum < parsed.value;
        case 'range':
          return searchNum >= parsed.min && searchNum <= parsed.max;
        default:
          return false;
      }
    },

    // 解析包含运算符的字符串
    parseOperatorValue(value) {
      value = value.trim();
      
      // 范围: 17.7-18.1 或 17.7~18.1
      const rangePattern = /^([\d.]+)\s*[-~]\s*([\d.]+)$/;
      const rangeMatch = value.match(rangePattern);
      if (rangeMatch) {
        return {
          operator: 'range',
          min: parseFloat(rangeMatch[1]),
          max: parseFloat(rangeMatch[2])
        };
      }

      // 大于等于: ≥10 或 >=10
      const gtePattern = /^(≥|>=)\s*([\d.]+)$/;
      const gteMatch = value.match(gtePattern);
      if (gteMatch) {
        return {
          operator: gteMatch[1],
          value: parseFloat(gteMatch[2])
        };
      }

      // 小于等于: ≤10 或 <=10
      const ltePattern = /^(≤|<=)\s*([\d.]+)$/;
      const lteMatch = value.match(ltePattern);
      if (lteMatch) {
        return {
          operator: lteMatch[1],
          value: parseFloat(lteMatch[2])
        };
      }

      // 大于: >10
      const gtPattern = /^>\s*([\d.]+)$/;
      const gtMatch = value.match(gtPattern);
      if (gtMatch) {
        return {
          operator: '>',
          value: parseFloat(gtMatch[1])
        };
      }

      // 小于: <10
      const ltPattern = /^<\s*([\d.]+)$/;
      const ltMatch = value.match(ltPattern);
      if (ltMatch) {
        return {
          operator: '<',
          value: parseFloat(ltMatch[1])
        };
      }

      return null;
    },

    resetFilters() {
      // 重置所有搜索条件
      Object.keys(this.searchFilters).forEach(key => {
        this.$set(this.searchFilters, key, '');
      });

      // 重置后重新应用过滤
      this.$nextTick(() => {
        this.filterTableData();
      });
    },

    getNestedValue(objStr, key) {
      try {
        // console.log(objStr, key);
        // const obj = JSON.parse(objStr);
        return objStr[key];
      } catch (e) {
        console.error('Error parsing JSON:', e);
        return '-';
      }
    }
  },
  mounted() {
      this.getAllClassIft();
    
    let id = this.$route.query.id;
      if (id) {
      this.setActiveTab(id);
      this.getMenuListByMobile(id)
      if(id === "308"){
        this.defaultActive = "311";
        this.handleSelect(311);
      }else if(id === "16"){
        this.defaultActive = "18";
        this.handleSelect(18);
      }else if(id === "759"){
        this.defaultActive = "812";
        this.handleSelect(812);
      }else if(id === "1"){
        this.defaultActive = "2";
        this.handleSelect(2);
      }else if(id === "111"){
        this.defaultActive = "113";
        this.handleSelect(113);
      }
      
  }
    let defaultActive = this.$route.query.defaultActive;
    if (defaultActive) {
       this.defaultActive = defaultActive;
       this.handleSelect(Number(defaultActive))
    }else{

    }
    let type = this.$route.query.type;
    if (type === "mobile_show_table") {
   
      this.type = type;
        this.handleSelect(this.$route.query.parentId);
    }
  
  },

   watch: {
    // 监听路由变化
    '$route'(to, from) {
      
      const { parentId, type,id } = to.query;
       this.type = type;
       if (type === 'mobile_show_table') {
         this.handleSelect(parentId);
       }else if (type === 'mobile') {
         this.getMenuListByMobile(parentId);
       }
    }
  }
}
</script>

<style >
@media screen and (min-width: 1200px) {
  .is-mobile {
    display: none;
  }
  .is-pc {
    display: block;
  }
  .chip-submit-form{
    margin-top: 24px;
    text-align: center;
  }

  .chip-submit {
    background: #FFFFFF;
    box-shadow: 0px 3px 30px 0px rgba(0, 24, 52, 0.09);
    border-radius: 11px;
    padding: 22px 23px 40px 23px;
    margin-top: 24px;
  }

  .chip-submit-title {
    font-weight: 500;
    font-size: 24px;
    color: #342D2D;
    text-align: center;
    padding-bottom: 14px;

  }

  .chip-submit-tip {
    font-weight: 500;
    font-size: 14px;
    color: #BFB7B7;
    text-align: center;

  }


  .chip-description {
    font-weight: 500;
    font-size: 13px;
    color: #6B6767;
    text-align: center;
    padding: 26px 0;
  }

  .chip-description img {
    width: 46px;
    height: auto;
  }

  .click-to-open {
    background: #007DC7;
    border-radius: 6px;
    font-weight: 500;
    font-size: 22px;
    color: #FFFFFF;
    padding: 13px 0 15px 0;
    text-align: center;
    cursor: pointer;
  }

  .chip-container {
    margin-top: 20px;
    background: #FFFFFF;
    box-shadow: 0px 3px 30px 0px rgba(0, 24, 52, 0.09);
    border-radius: 0px 0px 6px 6px;
  }

  .chip-name {
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    padding: 7px 0;

    background: #007DC7;
    text-align: center;
    /* overflow: hidden; */
    border-radius: 6px 6px 0px 0px;
  }


  .product-table {
    width: 100%;
    border: 1px solid #ddd;
    border-collapse: collapse;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    overflow: hidden;
    border-radius: 4px;
    /* margin: 20px 0; */
  }

  .table-header {
    display: flex;
    background-color: #f5f7fa;
    border-bottom: 2px solid #dfe4e8;
  }

  .table-row {
    display: flex;
    border-bottom: 1px solid #dfe4e8;
  }

  .table-row:last-child {
    border-bottom: none;
  }

  .table-row-even {
    background-color: #fff;
  }

  .table-row-odd {
    background-color: #fafafa;
  }

  .table-cell {
    flex: 1;
    padding: 10px 6px;
    text-align: center;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    word-break: break-word;
    transition: background-color 0.2s ease;
  }

  .header-cell {
    font-weight: 600;
    color: white;
    background-color: #007DC7;
    font-size: 12px;
    border-right: 1px solid #28a1e5;
  }

  .header-cell:last-child {
    border-right: none;
  }

  .html-content-container {
    /* margin: 20px 0; */
    padding: 0 20px ;
    background-color: #f9f9f9;
    border-radius: 8px;
    text-indent: 2em;
    /* border-left: 4px solid #007DC7; */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .html-content-wrapper {
    max-width: 100%;
  }

  .html-content {
    font-size: 14px;
    line-height: 1.6;
    color: #333;
  }

  .html-content img {
    width: calc(100% / 2 - 30px);
    height: auto;
    /* border-radius: 4px;
      margin: 10px 0; */
    /* display: block;
      margin-left: auto;
      margin-right: auto; */
  }

  .html-content h1,
  .html-content h2,
  .html-content h3,
  .html-content h4,
  .html-content h5,
  .html-content h6 {
    color: #007DC7;
    margin-top: 1.2em;
    margin-bottom: 0.8em;
  }

  .html-content p {
    margin: 10px 0;
  }

  .html-content ul,
  .html-content ol {
    padding-left: 20px;
    margin: 10px 0;
  }

  .html-content li {
    margin: 5px 0;
  }

  .html-content a {
    color: #007DC7;
    text-decoration: none;
  }

  .html-content a:hover {
    text-decoration: underline;
  }

  .html-content img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
    margin: 10px 0;
  }

  .html-content table {
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0;
  }

  .html-content td,
  .html-content th {
    border: 1px solid #ddd;
    padding: 8px 12px;
  }

  .html-content th {
    background-color: #f5f7fa;
  }

  .search-container {
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .search-form {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .el-form-item {
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .el-form-item__label {
    color: #333;
  }

  .body-cell {
    font-size: 13px;
    color: #606266;
    border-right: 1px solid #dfe4e8;
  }

  .body-cell:last-child {
    border-right: none;
  }

  .table-row:hover {
    background-color: #e6f7ff;
  }

  .table-row:hover .body-cell {
    background-color: #e6f7ff;
  }
}

/* 移动端适配 */
@media screen and (max-width: 1200px) {
 .ban, .is-pc {
    display: none;
  }
  .is-mobile {
    display: block;
  }

  html, body {
    background: #F5F6F7;
  }

  .mobile-menu{
    margin-top: 4vw;
    display: flex;
    flex-wrap: wrap;
    gap: 3vw;
    justify-content: space-between;
  }
  .mobile-menu-item{
      width: calc(100% / 2 - 2vw);
      text-align: center;
      padding: 16px  0;
      background: #7D7777;
      border-radius: 7px;
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
  }
  .mobile-menu-item:hover{
      background-color: #037DC5;
  }


.click-to-open {
    background: #007DC7;
    border-radius: 6px;
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    padding: 7px 0;
    text-align: center;
    cursor: pointer;
  }

  .chip-container {
    margin-top: 20px;
    background: #FFFFFF;
    box-shadow: 0px 3px 30px 0px rgba(0, 24, 52, 0.09);
    border-radius: 0px 0px 6px 6px;
  }

  .chip-name {
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    padding: 7px 0;

    background: #007DC7;
    text-align: center;
    /* overflow: hidden; */
    border-radius: 6px 6px 0px 0px;
  }


.chip-submit-form{
    margin-top: 24px;
    text-align: center;
  }

  .chip-submit {
    background: #FFFFFF;
    box-shadow: 0px 3px 30px 0px rgba(0, 24, 52, 0.09);
    border-radius: 11px;
    padding: 11px 12px 14px 12px;
    margin-top: 36px;
  }

  .chip-submit-title {
    font-weight: 500;
    font-size: 15px;
    color: #342D2D;
    text-align: center;
    padding-bottom: 14px;

  }

  .chip-submit-tip {
    font-weight: 500;
    font-size: 9px;
    color: #BFB7B7;
    text-align: center;
    padding: 0 8vw;

  }


  .chip-description {
    font-weight: 500;
    font-size: 13px;
    color: #6B6767;
    /* text-align: center; */
    padding: 12px 10px;
  }

  .chip-description img {
    width: 46px;
    height: auto;
  }









  .product-table {
    width: 100%;
    overflow-x: auto;
    margin: 20px 0;
  }

  /* 自定义滚动条样式 */
  .product-table::-webkit-scrollbar {
    height: 8px;
  }

  .product-table::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  .product-table::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  .product-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  .table-header,
  .table-row {
    display: flex;
    width: max-content;
  }

  .table-cell {
    min-width: 120px;
    width: 120px; /* 固定单元格宽度 */
    padding: 10px 8px;
    font-size: 12px;
    border-right: 1px solid #fff; /* 单元格右侧间隔线 */
    border-bottom: 1px solid #fff; /* 单元格底部间隔线 */
background: #EAEBED;
    /* 修改文本对齐和换行 */
    text-align: left;
    flex-direction: column;
    align-items: flex-start;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
  }

  .header-cell {
    width: 120px; /* 固定表头单元格宽度 */
    background-color: #007DC7;
    color: white;
    text-align: center; /* 表头居中 */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .table-cell:last-child {
    border-right: none;
  }

  .header-cell {
    background-color: #007DC7;
    color: white;
  }

  /* 左侧第一列悬浮效果 */
  .table-row {
    position: relative;
    
  }

  .table-cell:first-child {
    position: sticky;
    left: 0;
    z-index: 10;
    background: #EAEBED; /* 确保有白色背景 */
    border-right: 1px solid #fff; /* 添加右侧间隔线 */
    box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1); /* 添加轻微阴影以突出悬浮效果 */
  }

  .header-cell:first-child {
    position: sticky;
    left: 0;
    z-index: 20; /* 表头第一列需要更高的z-index */
    background-color: #007DC7; /* 确保表头背景颜色 */
    box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.2);
  }
}
</style>